import { render, staticRenderFns } from "./DashBoardTopCards.vue?vue&type=template&id=2ba09793&scoped=true"
import script from "./DashBoardTopCards.vue?vue&type=script&lang=js"
export * from "./DashBoardTopCards.vue?vue&type=script&lang=js"
import style0 from "./DashBoardTopCards.vue?vue&type=style&index=0&id=2ba09793&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba09793",
  null
  
)

export default component.exports